import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Role } from '../../../class/role';
import { RoleService } from '../../../service/role/role.service';
import { TranslateService } from '@ngx-translate/core';
import { MapsAPILoader } from '@agm/core';
import { SelectItem, MultiSelectModule, AutoCompleteModule, CalendarModule } from 'primeng/primeng';
import { Marker } from '../../../../../interfaces/marker';
import { NotificationsService } from '../../../../../theme/services/notifications/notifications.service';

@Component({
  selector: 'app-new-role',
  templateUrl: './new-role.component.html',
  styleUrls: ['./new-role.component.scss']
})
export class NewRoleComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() edit: Role;
    public promiseForm: Promise<any>;
    public form: FormGroup;
    public name: AbstractControl;
    public permissions: AbstractControl;
    public activated: AbstractControl;

    public save_exit: boolean;

    constructor(
        fb: FormBuilder,
        public roleService: RoleService,
        public translate: TranslateService,
        private ngZone: NgZone,
        private notificationsService: NotificationsService,
        private mapsAPILoader: MapsAPILoader) {

        this.save_exit = false;

        this.form = fb.group({
            'name': ['', Validators.compose([Validators.required, Validators.minLength(2)])],
            'permissions': [''],
            'activated': ['', Validators.compose([Validators.required])],
        });

        this.name = this.form.controls['name'];
        this.permissions = this.form.controls['permissions'];
        this.activated = this.form.controls['activated'];
    }

    ngOnInit() {
        if (this.edit) {
            this.name.setValue(this.edit.name);
            this.permissions.setValue(this.edit.permissions);
            this.activated.setValue(this.edit.activated);
        } else {
            this.activated.setValue(true);
        }
    }

    public cancelRole () {
        console.log('reset');
        this.form.reset();
        this.close.emit(true);
    }

    public saveandexit (values){
        this.save_exit = true;
        this.newRole(values);
    }

    checkPermissions(values) {
        let hint = "";
        const permissions = [];
        var test= values.permissions;
        if(Array.isArray(test)==false)
            return hint;
        values.permissions.forEach(element => {
            if (element.name == 'get user company') {
                hint = "Permiso 'get user company' es para usuarios tipo company";
            }
        });
        return hint;
    }

    public newRole(values) {
        const permissions = [];
        values.permissions.forEach(element => {
            permissions.push(element.value);
        });

        const param = {
            'name': values.name,
            'permissions': permissions,
            'activated': values.activated,
        };
        if (values && this.form.valid) {
            const promise = (this.edit) ?
                this.roleService.updateRole(this.edit.id, param)
                :
                this.roleService.newRole(param);

            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.notificationsService.growlNotify('success', res);
                        // this.msg.emit( { severity: 'success', summary: res  } );
                        if (this.save_exit) {
                            this.close.emit(true);
                            this.form.reset();
                            this.save_exit = false;
                        }
                    });
                },
                error => {
                    let msg = '';
                    this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                        this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                            JSON.parse(error._body).errors.forEach(element => {
                                if (element.source) {
                                    if (element.source.pointer) {
                                        this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                            msg = msg + res3 + ', ';
                                        });
                                    }
                                }
                            });
                            this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                            // this.msg.emit( { severity: 'error', summary: 'Error' } );
                        });
                    });
                }
            );
        }
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/roles/new-role/new-role.component.ts